export function resolveInitialPayload(initialPayload, key, expected) {
  if (!initialPayload) {
    return null;
  }

  if (typeof key === "function") {
    return key(initialPayload) ? initialPayload : null;
  }

  if (!key) {
    return initialPayload;
  }

  return initialPayload?.[key] === expected ? initialPayload : null;
}
